export default __webpack_public_path__ + "static/media/gallery_01.f43a3991.jpg";